import React, { useEffect, useRef } from "react";
import useDateTimePicker from "./useDateTimePicker.js";

const DEFAULT_DATE_FORMAT = "YYYY-MM-DD";

const DateInput = ({ name, defaultValue, placeholder, onChange = () => {}, pickerOptions = {}, disabled = false, pickerOverlay = false }) => {
  const isMounted = useRef(false);
  const [date, inputId] = useDateTimePicker(defaultValue, true, { format: DEFAULT_DATE_FORMAT, ...pickerOptions }, pickerOverlay);

  useEffect(() => {
    if (isMounted.current) {
      // Skip onChange-call on first render
      onChange(date ? dayjs(date).format(pickerOptions.format || DEFAULT_DATE_FORMAT) : "");
    } else {
      isMounted.current = true;
    }
  }, [date]);

  return <input id={inputId} type="text" name={name} className="form-control" defaultValue={date} placeholder={placeholder} disabled={disabled} />;
};

export default DateInput;
